import { useTranslation } from 'react-i18next';
import { CellType, ICell, SortType } from '../../../../base';

export const useTableCells = (): ICell[] => {
    const { t } = useTranslation();

    const cells: Array<ICell> = [
        {
            id: 'source',
            headerTitle: t('reportsPage.sourceOfHireReport.source'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'source' },
            isSortable: true,
            sortType: SortType.lexical,
            sortKey: 'source_title',
        },
        {
            id: 'clicks',
            headerTitle: t('reportsPage.sourceOfHireReport.clicks'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'clicks' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'clicks',
        },
        {
            id: 'applications',
            headerTitle: t('reportsPage.sourceOfHireReport.applications'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'applications' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'applications',
        },
        {
            id: 'screened',
            headerTitle: t('reportsPage.sourceOfHireReport.screened'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'screened' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'screened',
        },
        {
            id: 'hired',
            headerTitle: t('reportsPage.sourceOfHireReport.hired'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'hired' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'hired',
        },
        {
            id: 'clickApply',
            headerTitle: t('reportsPage.sourceOfHireReport.clickApply'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'clickApply' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'click_apply_percent',
        },
        {
            id: 'applyScreen',
            headerTitle: t('reportsPage.sourceOfHireReport.applyScreen'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'applyScreen' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'apply_screen_percent',
        },
        {
            id: 'overallConv',
            headerTitle: t('reportsPage.sourceOfHireReport.overallConv'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'overallConv' },
            isSortable: true,
            sortType: SortType.numeric,
            sortKey: 'overall_conversion',
        },
    ];

    cells.forEach((cell, index) => {
        cell.columnIndex = index;
    });

    return cells;
};
